window.assetsFolder = "/Areas/USP/assets";
